export default __webpack_public_path__ + "static/media/4.6bfbf93e.jpg";